<template>
  <div class="mb-content">
    <Header />

    <div class="contact-container">
      <div class="contact-header">
        <div class="contact-greeting">{{ $t('contact.greeting') }}</div>
        <div class="contact-sub">{{ $t('contact.subGreeting') }}</div>
      </div>

      <div class="contact-list">
        <div
          v-for="item in contactList"
          :key="item.type"
          class="contact-card"
        >
          <div class="contact-icon-wrap">
            <div class="contact-icon" :class="{ 'dark-icon': isDarkMode }">
              {{ item.icon }}
            </div>
          </div>

          <div class="contact-body">
            <div class="contact-title">{{ $t(`contact.${item.titleKey}`) }}</div>
            <div
              class="contact-value"
              :class="{ 'copyable': item.copyable }"
              @click="copyContactValue(item)"
            >
              {{ item.displayValue || item.value }}
              <span v-if="item.copyable" class="copy-hint">{{ $t('contact.copyHint') }}</span>
            </div>
            <div v-if="item.noteKey" class="contact-note">{{ $t(`contact.${item.noteKey}`) }}</div>
          </div>

          <!-- <div class="contact-action">
            <div class="contact-btn" @click="handleAction(item)">
              {{ $t(`contact.${item.actionKey}`) }}
            </div>
          </div> -->
        </div>
      </div>

      <div class="contact-footer-note">
        <div class="note-text">{{ $t('contact.footerNote') }}</div>
      </div>
    </div>

    <div class="bottom-space"></div>
  </div>
</template>

<script>
import Header from "@/components/module/header.vue";
import {Toast} from "vant";
import { contactInfo } from "@/apis/base";

export default {
  name: "ContactUs",
  components: { Header },
  data() {
    return {
      isDarkMode: false,
      themeObserver: null,
      contactList: [],
    };
  },
  mounted() {
    this.getContactInfo();
  },
  beforeDestroy() {
    if (this.themeObserver) {
      this.themeObserver.disconnect();
    }
  },
  methods: {
  getContactInfo() {
    contactInfo().then(res => {
      const list = (res || []).map(item => {
        if (!item.actionKey) {
          item.actionKey = this.getDefaultActionKey(item.type);
        }
        return item;
      });
      this.contactList = list;
    }).catch(err => {
      console.error("获取联系信息失败", err);
    });
  },

  getDefaultActionKey(type) {
    const map = {
      email: 'copy',
      whatsapp: 'message',
      line: 'addFriend'
    };
    return map[type] || 'copy';
  },

  isTikTokMinis() {
    return !!window.TTMinis;
  },

  shareByTikTokMinis(item) {
    if (!window.TTMinis || !item) return;

    const text = item.displayValue || item.value || '';
    const title = this.getShareTitle(item);
    const desc = text;

    window.TTMinis.share((result) => {
      if (result && result.is_success) {
        Toast(this.$t('contact.toastShareSuccess') || 'Shared');
      } else {
        Toast(this.$t('contact.toastShareFail') || 'Share failed');
      }
    }, {
      title,
      desc,
      query: {
        type: item.type,
        value: item.value
      }
    });
  },

  getShareTitle(item) {
    const map = {
      email: 'Email',
      whatsapp: 'WhatsApp',
      line: 'LINE'
    };
    return map[item.type] || 'Contact';
  },

  copyContactValue(item) {
    if (!item.copyable) return;

    const textToCopy = item.value;
    if (!textToCopy) return;

    if (this.isTikTokMinis()) {
      this.shareByTikTokMinis(item);
      return;
    }

    const copySuccess = () => {
      const typeMsg = this.getCopySuccessMsg(item.type);
      Toast(`${typeMsg} ${this.$t('contact.toastCopySuccess')}`);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(copySuccess)
        .catch(() => this.fallbackCopy(textToCopy));
    } else {
      this.fallbackCopy(textToCopy);
    }
  },

  fallbackCopy(text) {
    if (this.isTikTokMinis()) {
      Toast('Copy is not supported. Please share instead.');
      return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    Toast(this.$t('contact.toastCopySuccess'));
  },

  getCopySuccessMsg(type) {
    const map = {
      email: this.$t('contact.toastCopyEmail'),
      whatsapp: this.$t('contact.toastCopyWhatsapp'),
      line: this.$t('contact.toastCopyLine'),
    };
    return map[type] || "";
  },
  handleAction(item) {
    if (!item) return;

    if (this.isTikTokMinis()) {
      this.shareByTikTokMinis(item);
      return;
    }

    if (item.actionType === "copy" || item.actionKey === "copy") {
      this.copyContactValue(item);
    } else if ((item.actionType === "whatsapp" || item.actionKey === "message") && item.link) {
      window.location.href = item.link;
    } else if ((item.actionType === "line" || item.actionKey === "addFriend") && item.link) {
      window.location.href = item.link;
    } else {
      this.copyContactValue(item);
    }
  }
}
};
</script>

<style scoped>
/* 保持与原样式一致的基础容器 */
.mb-content {
  width: 100%;
  max-width: 450px;
  min-height: 100vh;
  margin: 0 auto;
  background: #f5f5f7;
  color: #1d1d1f;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif;
  transition: background 0.3s;
}

/* 深色/浅色模式由父级类控制，这里适配 */
.light .mb-content,
.mb-content:not(.dark) {
  background: #f5f5f7;
  color: #1d1d1f;
}

.dark .mb-content {
  background: #181818;
  color: #f3f3f3;
}

/* 联系我们主容器 */
.contact-container {
  padding: 18px 12px 0 !important;
}

/* 头部问候语 */
.contact-header {
  margin: 0 4px 18px;
  text-align: left;
}
.contact-greeting {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  color: #1d1d1f;
  line-height: 1.2;
}
.dark .contact-greeting {
  color: #e6d5b8;
}
.contact-sub {
  font-size: 13px;
  color: #8e8e93;
  margin-top: 7px;
  letter-spacing: 0;
  line-height: 1.45;
}
.dark .contact-sub {
  color: #bcb4a8;
}

/* 联系方式列表 */
.contact-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 卡片样式 复制历史卡片风格 */
.contact-card {
  display: flex;
  align-items: center;
  padding: 14px 12px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  backdrop-filter: none;
  transition: transform 0.12s ease, background 0.12s ease;
}
.contact-card:active {
  transform: scale(0.99);
  background: #f9f9fb;
}
.dark .contact-card {
  background: rgba(40, 40, 40, 0.92);
  border-color: rgba(255, 255, 255, 0.06);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* 左侧图标圆形区域 */
.contact-icon-wrap {
  flex-shrink: 0;
  margin-right: 12px;
}
.contact-icon {
  width: 42px;
  height: 42px;
  background: #f2f2f7;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  box-shadow: none;
}
.dark .contact-icon {
  background: rgba(70, 70, 70, 0.8);
}
.contact-icon.dark-icon {
  background: rgba(55, 55, 55, 0.9);
}

/* 中间主体 */
.contact-body {
  flex: 1;
  min-width: 0;
}
.contact-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 4px;
  letter-spacing: 0;
}
.dark .contact-title {
  color: #f0e4d0;
}
.contact-value {
  font-size: 13px;
  font-weight: 500;
  color: #3a3a3c;
  word-break: break-all;
  display: inline-block;
  background: transparent;
  padding: 0;
  border-radius: 0;
  transition: all 0.15s;
}
.dark .contact-value {
  color: #cfc6ba;
  background: rgba(255, 255, 255, 0.05);
}
.copyable {
  color: #007aff;
  cursor: pointer;
}
.copyable:active {
  transform: scale(0.98);
}
.copy-hint {
  font-size: 11px;
  margin-left: 6px;
  opacity: 1;
  font-weight: 500;
  letter-spacing: 0;
  color: #8e8e93;
}
.contact-note {
  font-size: 12px;
  color: #8e8e93;
  margin-top: 7px;
  letter-spacing: 0;
  line-height: 1.4;
}
.dark .contact-note {
  color: #9c8f82;
}

/* 右侧按钮 */
.contact-action {
  flex-shrink: 0;
  margin-left: 8px;
}
.contact-btn {
  height: 34px;
  padding: 0 15px;
  border-radius: 40px;
  background: #e8f2ff;
  color: #007aff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  box-shadow: none;
  cursor: pointer;
  transition: transform 0.12s, opacity 0.2s;
}
.contact-btn:active {
  transform: scale(0.96);
  opacity: 0.85;
}
.dark .contact-btn {
  background: #ffffff;
  color: #111111;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

/* 底部说明区域 */
.contact-footer-note {
  margin: 24px 4px 20px;
  padding: 0;
  background: transparent;
  border-radius: 0;
  text-align: center;
  border-top: 0;
}
.dark .contact-footer-note {
  background: rgba(255, 255, 255, 0.03);
}
.note-text {
  font-size: 12px;
  color: #8e8e93;
  line-height: 1.5;
  letter-spacing: 0;
}
.dark .note-text {
  color: #ac9f8f;
}
.bottom-space {
  width: 100%;
  height: 24px;
}

/* 简洁响应式适配 */
@media (max-width: 480px) {
  .contact-icon {
    width: 40px;
    height: 40px;
    font-size: 21px;
  }
  .contact-title {
    font-size: 15px;
  }
  .contact-value {
    font-size: 12px;
  }
  .contact-btn {
    padding: 0 12px;
    height: 32px;
    font-size: 11px;
  }
}
</style>
